<div class="container-fluid">
  <!-- Filter Row -->
  <div class="sub-bg p-3 mb-3">
    <form [formGroup]="filterForm">
      <div class="row align-items-end g-3">
        <!-- From Date -->
        <div class="col-md-2">
          <label class="form-label">{{ "From Date" | translate }}</label>
          <p-calendar
            formControlName="from_date"
            [showIcon]="true"
            [iconDisplay]="'input'"
            [dateFormat]="dateFormat"
            [placeholder]="'From Date' | translate"
            touchUI="true"
            styleClass="w-100 custom-calendar"
          ></p-calendar>
        </div>

        <!-- To Date -->
        <div class="col-md-2">
          <label class="form-label">{{ "To Date" | translate }}</label>
          <p-calendar
            formControlName="to_date"
            [showIcon]="true"
            [iconDisplay]="'input'"
            [dateFormat]="dateFormat"
            [placeholder]="'To Date' | translate"
            touchUI="true"
            styleClass="w-100 custom-calendar"
          ></p-calendar>
        </div>

        <!-- Company -->
        <div class="col-md-3">
          <label class="form-label">{{ "Company" | translate }}</label>
          <ng-select
            [items]="companyList"
            bindLabel="company_name"
            bindValue="id"
            [placeholder]="'All Companies' | translate"
            formControlName="company_id"
            [clearable]="true"
          ></ng-select>
        </div>

        <!-- Employee ID -->
        <div class="col-md-3">
          <label class="form-label">{{
            "Employee / Biometric ID" | translate
          }}</label>
          <input
            type="text"
            class="form-control"
            formControlName="employee_id"
            [placeholder]="'Search by Employee / Biometric ID' | translate"
          />
        </div>

        <!-- Buttons -->
        <div class="col-md-2 d-flex gap-2">
          <button type="button" class="btn submit btn-sm" (click)="search()">
            <i class="fa-solid fa-magnifying-glass me-1"></i
            >{{ "Search" | translate }}
          </button>
          <button type="button" class="btn cancel btn-sm" (click)="reset()">
            {{ "Reset" | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- Data Table -->
  <div class="sub-bg">
    <p-table
      styleClass="p-datatable-gridlines"
      [value]="listData"
      [loading]="loading"
      [tableStyle]="{ 'min-width': '60rem' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="tHead text-center" style="width: 5%">S.No</th>
          <th class="tHead">{{ "Employee ID" | translate }}</th>
          <th class="tHead">{{ "Punch Time" | translate }}</th>
          <th class="tHead">{{ "Sync Time" | translate }}</th>
          <th class="tHead text-center">{{ "Direction" | translate }}</th>
          <th class="tHead">{{ "Source API" | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-i="rowIndex">
        <tr>
          <td class="text-center">{{ (page - 1) * pageSize + i + 1 }}</td>
          <td>{{ row.employee_id || "---" }}</td>
          <td>
            {{
              row.punch_timestamp
                ? (row.punch_timestamp
                  | date: (angularDateFormat || "dd/MM/yyyy") + " hh:mm a")
                : "---"
            }}
          </td>
          <td>
            {{
              row.sync_datetime
                ? (row.sync_datetime
                  | date: (angularDateFormat || "dd/MM/yyyy") + " hh:mm a")
                : "---"
            }}
          </td>
          <td class="text-center">
            <span [ngClass]="directionClass(row.direction)">
              {{ directionLabel(row.direction) }}
            </span>
          </td>
          <td>
            <div>{{ row.source_api || "---" }}</div>
            <small class="text-muted">{{ row.api_url || "" }}</small>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center p-4">
            <span *ngIf="!loading">{{ "No Records Found" | translate }}</span>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr *ngFor="let _ of [1, 2, 3, 4, 5]">
          <td colspan="6" class="text-center"><p-skeleton></p-skeleton></td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Pagination -->
    <div
      class="d-flex justify-content-between align-items-center p-3"
      *ngIf="listData.length > 0"
    >
      <div class="d-flex align-items-center gap-2">
        <small class="text-muted">
          {{ "Showing" | translate }} {{ (page - 1) * pageSize + 1 }}–{{
            (page - 1) * pageSize + listData.length
          }}
          {{ "of" | translate }} {{ totalRecords }} {{ "records" | translate }}
        </small>
        <select
          class="form-select form-select-sm"
          style="width: auto"
          [ngModel]="pageSize"
          (ngModelChange)="handlePageSizeChange($event)"
        >
          <option *ngFor="let size of pageSizeOptions" [ngValue]="size">
            {{ size }} / {{ "page" | translate }}
          </option>
        </select>
      </div>
      <ngb-pagination
        class="pagination-master"
        [maxSize]="10"
        [collectionSize]="totalRecords"
        [(page)]="page"
        [pageSize]="pageSize"
        [rotate]="true"
        [ellipses]="false"
        [boundaryLinks]="true"
        (pageChange)="handlePageChange($event)"
      >
      </ngb-pagination>
    </div>
  </div>
</div>
